import React from 'react';
import block from 'bem-cn-lite';
import {Text} from '@gravity-ui/uikit';

import BasketErrorPng from '@assets/error-not-data.png';

import './BasketError.scss';

const b = block('basket-error');

export const BasketError = () => {
    return (
        <div className={b()}>
            <img src={BasketErrorPng} alt="error" className={b('image')}></img>

            <div className={b('text')}>
                <Text variant={'subheader-2'}>Что-то пошло не так...</Text>
                <Text variant={'body-2'}>
                    Попробуйте{' '}
                    <Text variant={'body-2'} color={'link'} onClick={() => window.location.reload()} className={b('link')}>
                        перезагрузить страницу
                    </Text>
                </Text>
            </div>
        </div>
    );
};
